import { render } from "./ModelConfig.vue?vue&type=template&id=f6414a08&scoped=true&ts=true"
import script from "./ModelConfig.vue?vue&type=script&lang=ts"
export * from "./ModelConfig.vue?vue&type=script&lang=ts"

import "./ModelConfig.vue?vue&type=style&index=0&id=f6414a08&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6414a08"]])

export default __exports__